<div
  class="page-wrapper d-flex flex-column align-items-center py-4 h-100"
  [class.gap-4]="!isOverview()"
  [class.gap-5]="isOverview()"
  [breakpoints]="breakpoints"
  (breakpointsStates)="getBreakpointsStates($event)"
>
  <div class="d-flex align-items-center justify-content-center" [class.mt-4]="isOverview()">
    <h1 class="m-0 fw-bold text-primary text-center {{ isMobile ? 'font-29' : 'font-41' }}">{{ title() | translate }}</h1>
  </div>

  <!-- The grid used to be gated on `requestStatus() !== undefined`, so a failed eligibility check
       hid every service with no explanation. It is now gated on the services themselves, and each
       outcome says what it is. -->
  @switch (servicesState().status) {
    @case ("unavailable") {
      <app-offline-state status="unavailable" [blocking]="true" messageKey="OFFLINE_STATE.SERVICES_UNAVAILABLE" (retry)="retry()" />
    }
    @case ("failed") {
      <app-offline-state status="failed" [blocking]="true" (retry)="retry()" />
    }
    @case ("loading") {
      <!-- Nothing here on purpose: the request carries the default loader context, so the global
           spinner is already covering this. The effect leaves the previous outcome on screen
           underneath it rather than blanking the page mid-retry. -->
    }
    @case ("ready") {
      @if (!services.length) {
        <p class="text-center m-0">{{ "EMPTY.NO_DATA" | translate }}</p>
      }
    }
  }

  @if (services.length) {
    <div class="w-100 h-100 d-flex flex-column align-items-center gap-5" [class.justify-content-center]="!isXLargeScreen" id="services">
      @for (eachSortedServices of sortedServices; let isLast = $last; track $index) {
        <div
          class="services w-100 w-xxl-auto d-grid"
          [attr.data-row]="eachSortedServices.length"
          [style]="{
            margin: isLast && !isMobile ? '0 auto' : '',
            'grid-auto-rows': 'minmax(calc(clamp(200px, calc(100% /' + (eachSortedServices.length + 1) + '), 250px) / 1.5), 1fr)',
            'grid-template-columns':
              'repeat(' +
              eachSortedServices.length +
              ', minmax(clamp(230px, calc(100% /' +
              eachSortedServices.length +
              ' - ' +
              (eachSortedServices.length - 1) +
              'rem), 250px),' +
              (isMobile ? '1' : isLast ? '0' : '0') +
              'fr))',
          }"
        >
          @for (eachSortedService of eachSortedServices; track $index) {
            @if (!isServiceHidden(eachSortedService, requestStatus())) {
              <app-service-card
                [style]="{
                  cursor: 'pointer',
                  width: isLast && $last ? '100%' : '',
                  margin: isLast && $last && !isMobile ? '0 auto' : '',
                  'max-width': isMobile ? '100%' : '250px',
                  'min-width':
                    isLast && !isMobile
                      ? 'clamp(200px, calc(100% /' +
                        (eachSortedServices.length === 1 ? sortedServices[0].length : eachSortedServices.length + 1) +
                        '), 250px)'
                      : '',
                }"
                [imageDisplaying]="false"
                [service]="eachSortedService"
                [requestStatus]="requestStatus()"
                titleClass="fw-bold"
              />
            }
          }
        </div>
      }
    </div>
  }

  <div class="terms-conditions text-primary" (click)="downloadTermsAndConditions()">
    {{ "SERVICES.TERMS_AND_CONDITIONS" | translate }}
  </div>
</div>
